import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

// material-ui
import { ButtonBase } from '@mui/material';

// project imports
import Logo from 'ui-component/Logo';
import { MENU_OPEN } from 'store/actions';
import { getLandingPath } from 'utils/roleAccess';

// ==============================|| MAIN LOGO ||============================== //

const LogoSection = () => {
  const defaultId = useSelector((state) => state.customization.defaultId);
  const dispatch = useDispatch();
  const role = localStorage.getItem('role');
  const landing = getLandingPath(role);

  return (
    <ButtonBase
      disableRipple
      onClick={() => {
        dispatch({ type: MENU_OPEN, id: defaultId });
        localStorage.setItem('selectedNavItemId', defaultId);
      }}
      component={Link}
      to={landing}
    >
      <Logo />
    </ButtonBase>
  );
};

export default LogoSection;
